import React from 'react';
import { cs } from '@bbkAdminUtils/css-utils';
import { Icons } from '@bbkAdminUtils/icons';
import { type ReactFCC } from '@bbkAdminUtils/utility-types';

import './card-content-area.scss';

type Props = {
  firstLoad?: boolean;
  loading?: boolean;
  noData?: boolean;
  customStyle?: React.CSSProperties;
};

const CardContentArea: ReactFCC<Props> = ({
  firstLoad = false,
  loading = false,
  noData = false,
  customStyle = {},
  children,
}) => (
  <div
    className={cs('bbk-card-content-box-body', {
      'box-loading': loading,
      'box-first-load': firstLoad,
      'box-no-data': noData,
    })}
    style={customStyle}
  >
    {(loading || firstLoad) && (
      <div className="box-loader">{Icons.loaderSW6}</div>
    )}
    {!firstLoad && !noData && children}
    {!loading && noData && (
      <div className="bbk-box-card-content-no-data">
        No data for this date range. Change the selected dates to view more
        data.
      </div>
    )}
  </div>
);

export default CardContentArea;
